export default __webpack_public_path__ + "static/canteen-presentation-88eaaade035a36f272b2e820e0e8c263.png";